import React from 'react'
import { useSearchParams } from 'react-router-dom';
import propTypes from 'prop-types';
import { useGAEvent } from '../ReactGA';

export const Tabs = React.memo(({ tabContent, customQuery }) => {
    let [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get('tab');
    const sendGAEvent = useGAEvent();

    const activeClass = `inline-block p-4 text-primary-400 border-b-2 border-blue-600 active px-0 py-2 font-semibold`;
    const normalClass = `inline-block p-4 text-secondary-500  hover:text-gray-600 hover:bg-gray-50 px-0 py-2 font-semibold`;

    const handleChangeTab = (tab) => {
        sendGAEvent({
            category:  tab?.query,
            action:`GA_TAB ${tab?.query?.toUpperCase()}`,
            label: tab?.query,
          });
        setSearchParams({...customQuery, tab: tab?.query })
    }

    const renderTabContent = React.useCallback(() => {
        const component = tabContent?.length && tabContent?.find(tab => (tab?.query === activeTab) || "");
        const { children } = component || { children: "" }
        return children
    }, [activeTab, tabContent])

    return (
        <div>
            <ul className="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400 mb-1">
                {!!tabContent?.length &&
                    tabContent?.map((tab) =>
                        <li key={tab.title} className="mr-5" onClick={() => handleChangeTab(tab)}>
                            <button className={activeTab === tab?.query ? activeClass : normalClass}>{tab?.title}</button>
                        </li>)}
            </ul>
            <div>
                {renderTabContent()}
            </div>
        </div>
    )
})

Tabs.propTypes = {
    tabContent: propTypes.array,
    customQuery: propTypes.object
}

Tabs.defaultProps = {
    tabContent: [
        { title: "Activity Log", query: "activity_logs", children: <></>},
        { title: "Assignment History ", query: "assignment_history", children:  <></>}
    ],
    customQuery: {}
}